import React from 'react';
import './EventExclusions.css';

export const EventExclusions = ({ exclusions = [] }) => {
  if (!exclusions || exclusions.length === 0) {
    return null;
  }

  return (
    <div className="event-exclusions-section">
      <div className="page-padding-2">
        <div className="container-medium">
          <div className="padding-vertical padding-small">
            <div className="exclusions-wrapper">
              <div className="exclusions-header">
                <h2 className="heading-7">What's Not Included</h2>
              </div>
              <div className="exclusions-list">
                {exclusions.map((item) => (
                  <div key={item.id || item._id} className="exclusion-item">
                    <span className="exclusion-text">{item.text}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="site_content-divider"></div>
        </div>
      </div>
    </div>
  );
};

export default EventExclusions;
